import { jsonProperty, Serializable } from 'ts-serializable';

import { SurveyResultAnswerModel } from '~modules/surveys/models/SurveyResultAnswerModel';

// Ответ пройденного опроса (readonly)
export class SurveyResultItemModel extends Serializable {
  @jsonProperty(Number, null) questionId: number | null = null;
  @jsonProperty(Number, null) answerTypeId: number | null = null;
  @jsonProperty(String, null) descr: string | null = null;
  @jsonProperty(Boolean, null) isNeedComment: boolean | null = null;
  @jsonProperty(String, null) dealerComment: string | null = null;
  @jsonProperty(Number, null) happyIndex: number | null = null;
  @jsonProperty(String, null) textValue: string | null = null;
  @jsonProperty([SurveyResultAnswerModel]) answers: SurveyResultAnswerModel[] = [];
}
